import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import FlexContainer from "../components/flex-container.js";
import SidebarLeft from "../components/sidebar-left.js";
import SidebarRight from "../components/sidebar-right.js";
import Container from '../components/container.js'
import ImageFooter from '../components/image-footer-a-propos.js'
import SvgHamburger from "../../images/hamburger.svg"

const SecondPage = () => (
    <div>
    <FlexContainer>
        <Helmet bodyAttributes={{class: 'hamburger'}}/>
        <SidebarLeft></SidebarLeft>
        <Container>
            <SvgHamburger/>
            <h1>À propos</h1>
            <p>Ludovica est un projet d’idées, d’écritures et d’audio-visions initié par David N. Bernatchez. Inspiré par Québec, une ville aussi modeste en démographie que riche en histoires et en résilience, le projet propose une sorte de distillerie fine. Personnages et lieux, mémoires et archives, utopies et dystopies y macèrent en fragments. Regroupés autour de 5 grands axes, ces fragments sont articulés comme des parcours possibles. Élixir à fermentation prolongée, le long métrage Ludovica verra le jour lors de la saison 2018-2019: avant donc, le retour des Nordiques...</p>
            <br/>
            <h2 className="like-h2">Personnes et personnages</h2>
            <p>À l’origine des personnages historiques se trouve une suite de personnes qui ont, en leur temps, agi pour le meilleur et pour le pire. D’hier et d’aujourd’hui, inconnues ou reconnues: dans le moteur de Ludovica, les personnes deviennent des personnages.</p>
            <br/>
            <h3 className="like-h2">Lieux</h3>
            <p>Qu'est-ce que l'esprit d'un lieu? Comment lire, dans l'histoire et dans les mémoires, des connexions entre les personnages, l'esprit et le lieu? Les réponses possibles sont nombreuses, les relations pouvant mourir vite ou durer très longtemps. On vous propose quelques pistes.</p>
            <br/>
            <h4 className="like-h2">Des collectifs en capsules</h4>
            <p>Dans le cadre d'une suite de capsules produites pour la Fabrique culturelle, je me suis intéressé à des démarches créatives susceptibles de faire miroiter plus qu'elles-mêmes. J’ai librement mis ces démarches en écho avec des fragments choisis, et j’ai laissé mijoter le tout sur la table de montage. <em>EP4 percussion</em>, <em>Les Violons du Roy</em>, <em>l’Orchestre d’Hommes-Orchestres</em> et <em>La Fête</em> m'ont fait confiance et je les en remercie. Ils contribuent tous, à leur manière, à faire de Québec plus qu'un reflet d'elle-même. Dans une ville habitée par l’histoire et mise-en-scène comme telle, ce mouvement est d'autant plus nécessaire: il aide à garder les choses en vie.</p>
        </Container>
        <SidebarRight>
        </SidebarRight>
    </FlexContainer>
    <ImageFooter/>
    </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/a-propos.js